import HomePage from 'components/Home/HomePage';
import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';
import { useEffect } from "react";




function Home() {

  const isMobile = useSelector(state => state.windowSize.isMobile);
  
  useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <HomePage />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <HomePage />
        <hr />
        <Footer />
      </>
    )}
    </>
  );
}

export default Home;



